<script setup>
import { ref, onMounted } from "vue";
const hasPrev = ref(false); // 是否可以滚动到上一项
const hasNext = ref(true); // 是否可以滚动到下一项
// 检查滚动位置，更新按钮状态
const handleScroll = () => {
  if (content7.value) {
    const { scrollLeft, scrollWidth, clientWidth } = content7.value;
    hasPrev.value = scrollLeft > 0; // 如果 scrollLeft > 0，说明可以滚动到上一项
    hasNext.value = scrollLeft + clientWidth < scrollWidth; // 如果 scrollLeft + clientWidth < scrollWidth，说明可以滚动到下一项
  }
};
// 滚动到上一项
const scrollPrev = () => {
  if (content7.value) {
    content7.value.scrollBy({
      left: -300, // 向左滚动一个容器的宽度
      behavior: "smooth", // 平滑滚动
    });
  }
};

// 滚动到下一项
const scrollNext = () => {
  if (content7.value) {
    content7.value.scrollBy({
      left: 300, // 向右滚动一个容器的宽度
      behavior: "smooth", // 平滑滚动
    });
  }
};
const tab = ref({
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
  7: false,
});
const content1 = ref();
const content2 = ref();
const content3 = ref();
const content4 = ref();
const content5 = ref();
const content6 = ref();
const content7 = ref();
const changeTab = (i) => {
  tab.value[i] = !tab.value[i];
};
</script>
<template>
  <main class="mt-[60px] md:mt-[70px]">
    <div>
      <div class="mx-auto flex max-w-[960px] gap-10 px-4 pb-4 lg:px-0">
        <div class="w-full flex-1 md:max-w-[600px]">
          <div class="mb-4 sm:mb-6">
            <div
              class="no-scrollbar flex overflow-x-auto mt-4 pt-0 md:mt-5"
              aria-label="Breadcrumb"
            >
              <ol class="inline-flex items-center">
                <li>
                  <div class="flex items-center text-sm font-normal">
                    <a
                      href="/"
                      class="whitespace-nowrap text-gray-accent3 hover:text-breadcrumb-link-hover"
                      >Home</a
                    >
                    <div class="px-2">/</div>
                  </div>
                </li>
                <li>
                  <div class="flex items-center text-sm font-normal">
                    <a
                      href="/calculator/"
                      class="whitespace-nowrap text-gray-accent3 hover:text-breadcrumb-link-hover"
                      >Calculators</a
                    >
                    <div class="px-2">/</div>
                  </div>
                </li>
                <li
                  class="w-50 truncate pr-7 text-sm font-normal text-lighter-black sm:w-72"
                >
                  EMI Calculator
                </li>
              </ol>
            </div>
            <h1
              class="my-1 mb-4 mt-6 text-2xl font-semibold not-italic leading-8 tracking-[-0.24px] sm:mb-2"
            >
              EMI Calculator
            </h1>
            <h2
              class="mb-4 text-sm font-normal not-italic leading-6 text-grey-8 sm:mb-8 md:text-base"
            >
              Calculate your EMI easily with EMI Calculator – input amount,
              interest rate, and tenure to get started.
            </h2>
            <div
              class="no-scrollbar border-b-blacks-3 flex h-[var(--tab-bar-height)] overflow-x-scroll border-b hidden"
            >
              <a
                class="display-xxs ipad:mr-4 mr-2 flex flex-shrink-0 cursor-pointer border-b-2 border-b-primary-base pb-2 font-semibold text-main-6"
                href="/calculator/emi-calculator/"
                ><div class="ipad:px-1 px-3">EMI</div></a
              ><a
                class="display-xxs ipad:mr-4 mr-2 flex flex-shrink-0 cursor-pointer text-dark-2 transition-colors"
                href="/calculator/home-loan-emi-calculator/"
                ><div class="ipad:px-1 px-3">Home loan</div></a
              ><a
                class="display-xxs ipad:mr-4 mr-2 flex flex-shrink-0 cursor-pointer text-dark-2 transition-colors"
                href="/calculator/car-loan-emi-calculator/"
                ><div class="ipad:px-1 px-3">Car loan</div></a
              ><a
                class="display-xxs ipad:mr-4 mr-2 flex flex-shrink-0 cursor-pointer text-dark-2 transition-colors"
                href="/calculator/bike-loan-emi-calculator/"
                ><div class="ipad:px-1 px-3">Bike loan</div></a
              ><a
                class="display-xxs ipad:mr-4 mr-2 flex flex-shrink-0 cursor-pointer text-dark-2 transition-colors"
                href="/calculator/credit-card-emi-calculator/"
                ><div class="ipad:px-1 px-3">Credit card</div></a
              ><a
                class="display-xxs ipad:mr-4 mr-2 flex flex-shrink-0 cursor-pointer text-dark-2 transition-colors"
                href="/calculator/personal-loan-emi-calculator/"
                ><div class="ipad:px-1 px-3">Personal loan</div></a
              >
            </div>
          </div>
          <h2 class="m-0 mb-4 text-lg font-semibold not-italic leading-[26px]">
            Calculate your Loan EMI
          </h2>
          <div class="mb-9 flex flex-col gap-6 sm:mb-10">
            <div>
              <div class="flex w-full items-center justify-between mb-2">
                <div class="w-full max-w-[173px] md:max-w-[551px]">
                  <label
                    class="text-sm leading-5 text-black-6 font-semibold"
                    for="principle"
                    >Loan amount</label
                  >
                </div>
                <div class="relative">
                  <span
                    class="absolute left-3 top-[10px] mr-6 text-xs font-medium leading-4 text-dark-2"
                    >₹</span
                  ><input
                    class="h-[36px] rounded border border-grey-9 px-3 py-2 text-xs font-medium leading-4 disabled:cursor-not-allowed disabled:bg-grey-7 disabled:text-grey-2 pl-[20px] w-[112px] md:w-[112px]"
                    type="text"
                    id="principle"
                    name="principle"
                    value="500000"
                  />
                </div>
              </div>
              <span
                dir="ltr"
                data-orientation="horizontal"
                aria-disabled="false"
                class="relative flex h-[50px] w-full select-none items-center px-2"
                aria-label="Volume"
                style="--radix-slider-thumb-transform: translateX(-50%)"
                ><div
                  class="relative h-[2px] flex-grow cursor-pointer rounded-[4px] bg-gray-accent"
                >
                  <span
                    data-orientation="horizontal"
                    class="absolute h-full rounded-full bg-primary-base"
                    style="left: 0%; right: 97.5%"
                  ></span>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 0%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] invisible bg-primary-base"
                    ></div>
                    <span
                      class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-30%]"
                      >0</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 12.5%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >25L</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 25%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >50L</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 37.5%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >75L</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 50%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >1Cr</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 62.5%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >1.25Cr</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 75%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >1.5Cr</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 87.5%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >1.75Cr</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 100%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent invisible"
                    ></div>
                    <span
                      class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-70%]"
                      >2Cr</span
                    >
                  </div>
                </div>
                <span
                  style="
                    transform: var(--radix-slider-thumb-transform);
                    position: absolute;
                    left: calc(2.5% + 11.4px);
                  "
                  ><span
                    role="slider"
                    aria-valuemin="0"
                    aria-valuemax="20000000"
                    aria-orientation="horizontal"
                    data-orientation="horizontal"
                    tabindex="0"
                    class="flex h-6 w-6 cursor-pointer rounded-full bg-primary-base focus:outline-none"
                    style=""
                    data-radix-collection-item=""
                    aria-valuenow="500000"
                  ></span></span
              ></span>
            </div>
            <div>
              <div class="flex w-full items-center justify-between mb-2">
                <div class="w-full max-w-[173px] md:max-w-[551px]">
                  <label
                    class="text-sm leading-5 text-black-6 font-semibold"
                    for="interest"
                    >Interest rate per annum</label
                  >
                </div>
                <div class="relative">
                  <input
                    class="h-[36px] rounded border border-grey-9 px-3 py-2 text-xs font-medium leading-4 disabled:cursor-not-allowed disabled:bg-grey-7 disabled:text-grey-2 pr-6 w-[112px] md:w-[112px]"
                    type="text"
                    id="interest"
                    name="interest"
                    value="7"
                  /><span
                    class="absolute right-3 top-[10px] text-xs font-medium leading-4 text-dark-2"
                    >%</span
                  >
                </div>
              </div>
              <span
                dir="ltr"
                data-orientation="horizontal"
                aria-disabled="false"
                class="relative flex h-[50px] w-full select-none items-center px-2"
                aria-label="Volume"
                style="--radix-slider-thumb-transform: translateX(-50%)"
                ><div
                  class="relative h-[2px] flex-grow cursor-pointer rounded-[4px] bg-gray-accent"
                >
                  <span
                    data-orientation="horizontal"
                    class="absolute h-full rounded-full bg-primary-base"
                    style="left: 0%; right: 82.5%"
                  ></span>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 0%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] invisible bg-primary-base"
                    ></div>
                    <span
                      class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-30%]"
                      >0%</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 12.5%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-primary-base"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >5%</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 25%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >10%</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 37.5%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >15%</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 50%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >20%</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 62.5%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >25%</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 75%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >30%</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 87.5%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >35%</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 100%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent invisible"
                    ></div>
                    <span
                      class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-70%]"
                      >40%</span
                    >
                  </div>
                </div>
                <span
                  style="
                    transform: var(--radix-slider-thumb-transform);
                    position: absolute;
                    left: calc(17.5% + 7.8px);
                  "
                  ><span
                    role="slider"
                    aria-valuemin="0"
                    aria-valuemax="40"
                    aria-orientation="horizontal"
                    data-orientation="horizontal"
                    tabindex="0"
                    class="flex h-6 w-6 cursor-pointer rounded-full bg-primary-base focus:outline-none"
                    style=""
                    data-radix-collection-item=""
                    aria-valuenow="7"
                  ></span></span
              ></span>
            </div>
            <div class="pb-2">
              <div class="mb-2 flex items-center justify-between">
                <label class="text-sm leading-5 text-black-6 font-semibold"
                  >Loan tenure</label
                >
                <div class="flex gap-2">
                  <input
                    class="h-[36px] w-[56px] rounded border border-grey-9 px-2 py-2 text-xs font-medium leading-4 disabled:cursor-not-allowed disabled:bg-grey-7 disabled:text-grey-2"
                    type="text"
                    id="tenure"
                    name="tenure"
                    value="5"
                  />
                  <div
                    class="flex items-center justify-between w-[104px] mb-0 h-[36px]"
                  >
                    <div
                      id="tenureUnit"
                      class="relative md:max-w-[250px] bg-white w-[104px] md:min-w-[104px] border rounded border-grey-9"
                    >
                      <div
                        class="flex h-[36px] cursor-pointer items-center justify-between rounded border px-2 md:px-3"
                      >
                        <div
                          class="flex items-center text-xs font-medium leading-4"
                        >
                          <span class="mr-2 text-xs">Year(s)</span>
                        </div>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            id="keyboard_arrow_down_FILL0_wght400_GRAD0_opsz24 1"
                          >
                            <path
                              id="Vector"
                              d="M8 10.2666L4 6.26665L4.93333 5.33331L8 8.39998L11.0667 5.33331L12 6.26665L8 10.2666Z"
                              fill="black"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                dir="ltr"
                data-orientation="horizontal"
                aria-disabled="false"
                class="relative flex h-[50px] w-full select-none items-center px-2"
                aria-label="Volume"
                style="--radix-slider-thumb-transform: translateX(-50%)"
                ><div
                  class="relative h-[2px] flex-grow cursor-pointer rounded-[4px] bg-gray-accent"
                >
                  <span
                    data-orientation="horizontal"
                    class="absolute h-full rounded-full bg-primary-base"
                    style="left: 0%; right: 83.33333333333333%"
                  ></span>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 0%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] invisible bg-primary-base"
                    ></div>
                    <span
                      class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-30%]"
                      >0Y</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 16.666666666666664%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-primary-base"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >5Y</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 33.33333333333333%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >10Y</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 50%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >15Y</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 66.66666666666666%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >20Y</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 83.33333333333334%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                    ></div>
                    <span
                      class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                      >25Y</span
                    >
                  </div>
                  <div
                    class="absolute top-[-3px] flex flex-col gap-2"
                    style="left: 100%"
                  >
                    <div
                      class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent invisible"
                    ></div>
                    <span
                      class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-70%]"
                      >30Y</span
                    >
                  </div>
                </div>
                <span
                  style="
                    transform: var(--radix-slider-thumb-transform);
                    position: absolute;
                    left: calc(16.6667% + 8px);
                  "
                  ><span
                    role="slider"
                    aria-valuemin="0"
                    aria-valuemax="30"
                    aria-orientation="horizontal"
                    data-orientation="horizontal"
                    tabindex="0"
                    class="flex h-6 w-6 cursor-pointer rounded-full bg-primary-base focus:outline-none"
                    style=""
                    data-radix-collection-item=""
                    aria-valuenow="5"
                  ></span></span
              ></span>
            </div>
          </div>
          <div
            class="mb-9 flex flex-col items-center gap-[4px] self-stretch rounded-[4px] border border-[#E5E5E5] bg-white sm:mb-10"
          >
            <div
              class="flex flex-col items-start gap-[10px] self-stretch border-b border-[#E5E5E5] bg-[#F5F5F5] px-[16px] py-[12px]"
            >
              <p
                class="text-center text-[14px] font-semibold leading-[20px] text-grey-8"
              >
                Payment breakdown
              </p>
            </div>
            <div
              class="flex w-[100%] flex-col md:w-[100%] md:flex-row md:justify-center md:px-6 md:py-6"
            >
              <!--$--><!--/$-->
              <div
                class="relative h-[273px] w-[100%] md:h-[252px] md:w-[291px]"
              >
                <div
                  class="recharts-responsive-container"
                  style="width: 100%; height: 100%; min-width: 0px"
                >
                  <div
                    class="recharts-wrapper"
                    style="
                      position: relative;
                      cursor: default;
                      width: 100%;
                      height: 100%;
                      max-height: 252px;
                      max-width: 291px;
                    "
                  >
                    <svg
                      cx="50%"
                      cy="50%"
                      class="recharts-surface"
                      width="291"
                      height="252"
                      viewBox="0 0 291 252"
                      style="width: 100%; height: 100%"
                    >
                      <title></title>
                      <desc></desc>
                      <defs>
                        <clipPath id="recharts1-clip">
                          <rect x="5" y="5" height="162" width="281"></rect>
                        </clipPath>
                      </defs>
                      <g
                        class="recharts-layer recharts-pie h-40 w-40 outline-none"
                        tabindex="0"
                      >
                        <g class="recharts-layer">
                          <g
                            class="recharts-layer recharts-pie-sector"
                            tabindex="-1"
                          >
                            <path
                              cx="145.5"
                              cy="86"
                              name="Interest amount"
                              class="recharts-sector h-40 w-40 outline-none"
                              stroke="#fff"
                              fill="#61339F"
                              cursor="pointer"
                              tabindex="-1"
                              d="M 225.5,86
    A 80,80,0,
    0,0,
    189.0851259876663,18.915450417855098
  L 173.8303318919831,42.395042771605816
            A 52,52,0,
            0,1,
            197.5,86 Z"
                              role="img"
                            ></path>
                          </g>
                          <g
                            class="recharts-layer recharts-pie-sector"
                            tabindex="-1"
                          >
                            <path
                              cx="145.5"
                              cy="86"
                              name="Principal amount"
                              class="recharts-sector h-40 w-40 outline-none"
                              stroke="#fff"
                              fill="#AE8AD2"
                              cursor="pointer"
                              tabindex="-1"
                              d="M 189.0851259876663,18.915450417855098
    A 80,80,0,
    1,0,
    225.5,85.99999999999994
  L 197.5,85.99999999999997
            A 52,52,0,
            1,1,
            173.8303318919831,42.395042771605816 Z"
                              role="img"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <div
                      class="recharts-legend-wrapper"
                      style="
                        position: absolute;
                        width: 281px;
                        height: auto;
                        left: 5px;
                        bottom: 5px;
                      "
                    >
                      <ul
                        class="relative top-[6px] flex w-[100%] list-none justify-evenly p-[16px]"
                      >
                        <li class="flex flex-col gap-[4px]">
                          <div
                            class="h-[4px] w-[21px]"
                            style="background-color: rgb(97, 51, 159)"
                          ></div>
                          <span
                            class="text-[13px] font-normal leading-[16px] text-grey-8"
                            >Interest amount</span
                          ><span
                            class="text-[14px] font-semibold leading-[20px] text-black sm:text-dark-6"
                            >₹ 94,035</span
                          >
                        </li>
                        <li class="flex flex-col gap-[4px]">
                          <div
                            class="h-[4px] w-[21px]"
                            style="background-color: rgb(174, 138, 210)"
                          ></div>
                          <span
                            class="text-[13px] font-normal leading-[16px] text-grey-8"
                            >Principal amount</span
                          ><span
                            class="text-[14px] font-semibold leading-[20px] text-black sm:text-dark-6"
                            >₹ 5,00,000</span
                          >
                        </li>
                      </ul>
                    </div>
                    <div
                      tabindex="-1"
                      class="recharts-tooltip-wrapper"
                      style="
                        visibility: hidden;
                        pointer-events: none;
                        position: absolute;
                        top: 0px;
                        left: 0px;
                      "
                    ></div>
                  </div>
                </div>
              </div>
              <div
                class="flex flex-row justify-between gap-4 border-t border-x-grey-7 px-6 py-7 md:flex-col md:justify-start md:border-l md:border-t-0 md:border-x-gray-300"
              >
                <div
                  class="flex flex-col content-between gap-1 md:content-start md:border-b md:border-x-gray-300 md:pb-4"
                >
                  <p class="text-sm font-medium leading-5 text-dark-2">
                    Monthly EMI
                  </p>
                  <p
                    class="overflow-hidden text-[16px] font-semibold leading-6 text-black sm:text-dark-6 md:text-[20px] md:leading-8"
                  >
                    ₹
                    <!-- -->9,900
                  </p>
                </div>
                <div class="flex flex-col gap-1">
                  <p class="text-sm font-medium leading-5 text-dark-2">
                    Total amount payable
                  </p>
                  <p
                    class="overflow-hidden text-[16px] font-semibold leading-6 text-black sm:text-dark-6 md:text-[20px] md:leading-8"
                  >
                    ₹
                    <!-- -->5,94,035
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col">
            <h2 class="m-0 text-lg font-semibold not-italic leading-[26px]">
              Amortisation schedule
            </h2>
            <div
              class="mb-6 mt-5 flex flex-wrap justify-between md:flex-nowrap"
            >
              <span class="w-[160px] text-sm font-normal not-italic leading-5"
                >Schedule showing EMI payments starting from</span
              >
            </div>
            <div class="mb-9 hidden sm:mb-10 md:block">
              <div class="aspect-[1.36] w-[100%]">
                <div
                  class="recharts-responsive-container"
                  style="width: 100%; height: 100%; min-width: 0px"
                >
                  <div
                    class="recharts-wrapper"
                    style="
                      position: relative;
                      cursor: default;
                      width: 100%;
                      height: 100%;
                      max-height: 441px;
                      max-width: 600px;
                    "
                  >
                    <svg
                      class="recharts-surface"
                      width="600"
                      height="441"
                      viewBox="0 0 600 441"
                      style="width: 100%; height: 100%"
                    >
                      <title></title>
                      <desc></desc>
                      <defs>
                        <clipPath id="recharts3-clip">
                          <rect x="60" y="6" height="369" width="480"></rect>
                        </clipPath>
                      </defs>
                      <g class="recharts-cartesian-grid">
                        <g class="recharts-cartesian-grid-horizontal">
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="60"
                            y1="375"
                            x2="540"
                            y2="375"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="60"
                            y1="282.75"
                            x2="540"
                            y2="282.75"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="60"
                            y1="190.5"
                            x2="540"
                            y2="190.5"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="60"
                            y1="98.25"
                            x2="540"
                            y2="98.25"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="60"
                            y1="6"
                            x2="540"
                            y2="6"
                          ></line>
                        </g>
                        <g class="recharts-cartesian-grid-vertical">
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="100"
                            y1="6"
                            x2="100"
                            y2="375"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="180"
                            y1="6"
                            x2="180"
                            y2="375"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="260"
                            y1="6"
                            x2="260"
                            y2="375"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="340"
                            y1="6"
                            x2="340"
                            y2="375"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="420"
                            y1="6"
                            x2="420"
                            y2="375"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="500"
                            y1="6"
                            x2="500"
                            y2="375"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="60"
                            y1="6"
                            x2="60"
                            y2="375"
                          ></line>
                          <line
                            stroke="#E5E5E5"
                            stroke-width="2"
                            fill="none"
                            x="60"
                            y="6"
                            width="480"
                            height="369"
                            x1="540"
                            y1="6"
                            x2="540"
                            y2="375"
                          ></line>
                        </g>
                      </g>
                      <g
                        class="recharts-layer recharts-cartesian-axis recharts-xAxis xAxis axis-ticks"
                      >
                        <line
                          stroke="#929292"
                          stroke-width="1"
                          class="recharts-cartesian-axis-line"
                          orientation="bottom"
                          width="480"
                          height="30"
                          x="60"
                          y="375"
                          fill="none"
                          x1="60"
                          y1="375"
                          x2="540"
                          y2="375"
                        ></line>
                        <g class="recharts-cartesian-axis-ticks">
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="60"
                              y="375"
                              fill="none"
                              x1="100"
                              y1="381"
                              x2="100"
                              y2="375"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="100"
                              y="383"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="middle"
                              fill="#929292"
                            >
                              <tspan x="100" dy="0.71em">2025</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="60"
                              y="375"
                              fill="none"
                              x1="180"
                              y1="381"
                              x2="180"
                              y2="375"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="180"
                              y="383"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="middle"
                              fill="#929292"
                            >
                              <tspan x="180" dy="0.71em">2026</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="60"
                              y="375"
                              fill="none"
                              x1="260"
                              y1="381"
                              x2="260"
                              y2="375"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="260"
                              y="383"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="middle"
                              fill="#929292"
                            >
                              <tspan x="260" dy="0.71em">2027</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="60"
                              y="375"
                              fill="none"
                              x1="340"
                              y1="381"
                              x2="340"
                              y2="375"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="340"
                              y="383"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="middle"
                              fill="#929292"
                            >
                              <tspan x="340" dy="0.71em">2028</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="60"
                              y="375"
                              fill="none"
                              x1="420"
                              y1="381"
                              x2="420"
                              y2="375"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="420"
                              y="383"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="middle"
                              fill="#929292"
                            >
                              <tspan x="420" dy="0.71em">2029</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="60"
                              y="375"
                              fill="none"
                              x1="500"
                              y1="381"
                              x2="500"
                              y2="375"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="bottom"
                              width="480"
                              height="30"
                              x="500"
                              y="383"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="middle"
                              fill="#929292"
                            >
                              <tspan x="500" dy="0.71em">2030</tspan>
                            </text>
                          </g>
                        </g>
                        <text
                          offset="-4"
                          x="300"
                          y="409"
                          class="recharts-text axis-label"
                          text-anchor="middle"
                          fill="#808080"
                        >
                          <tspan x="300" dy="0em">Year</tspan>
                        </text>
                      </g>
                      <g
                        class="recharts-layer recharts-cartesian-axis recharts-yAxis yAxis axis-ticks"
                      >
                        <line
                          stroke="#929292"
                          stroke-width="1"
                          class="recharts-cartesian-axis-line"
                          orientation="left"
                          width="60"
                          height="369"
                          x="0"
                          y="6"
                          fill="none"
                          x1="60"
                          y1="6"
                          x2="60"
                          y2="375"
                        ></line>
                        <g class="recharts-cartesian-axis-ticks">
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="left"
                              width="60"
                              height="369"
                              x="0"
                              y="6"
                              fill="none"
                              x1="54"
                              y1="375"
                              x2="60"
                              y2="375"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="left"
                              width="60"
                              height="369"
                              x="52"
                              y="375"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="end"
                              fill="#929292"
                            >
                              <tspan x="52" dy="0.355em">0</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="left"
                              width="60"
                              height="369"
                              x="0"
                              y="6"
                              fill="none"
                              x1="54"
                              y1="282.75"
                              x2="60"
                              y2="282.75"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="left"
                              width="60"
                              height="369"
                              x="52"
                              y="282.75"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="end"
                              fill="#929292"
                            >
                              <tspan x="52" dy="0.355em">₹ 2L</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="left"
                              width="60"
                              height="369"
                              x="0"
                              y="6"
                              fill="none"
                              x1="54"
                              y1="190.5"
                              x2="60"
                              y2="190.5"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="left"
                              width="60"
                              height="369"
                              x="52"
                              y="190.5"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="end"
                              fill="#929292"
                            >
                              <tspan x="52" dy="0.355em">₹ 3L</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="left"
                              width="60"
                              height="369"
                              x="0"
                              y="6"
                              fill="none"
                              x1="54"
                              y1="98.25"
                              x2="60"
                              y2="98.25"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="left"
                              width="60"
                              height="369"
                              x="52"
                              y="98.25"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="end"
                              fill="#929292"
                            >
                              <tspan x="52" dy="0.355em">₹ 5L</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              orientation="left"
                              width="60"
                              height="369"
                              x="0"
                              y="6"
                              fill="none"
                              x1="54"
                              y1="6"
                              x2="60"
                              y2="6"
                            ></line>
                            <text
                              stroke="none"
                              stroke-width="1"
                              orientation="left"
                              width="60"
                              height="369"
                              x="52"
                              y="7.5"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="end"
                              fill="#929292"
                            >
                              <tspan x="52" dy="0.355em">₹ 6L</tspan>
                            </text>
                          </g>
                        </g>
                        <text
                          offset="5"
                          transform="rotate(-90, 14, 190.5)"
                          x="14"
                          y="190.5"
                          class="recharts-text axis-label"
                          text-anchor="middle"
                          fill="#808080"
                        >
                          <tspan x="14" dy="0.355em">
                            Outstanding balance at the end of the year
                          </tspan>
                        </text>
                      </g>
                      <g
                        class="recharts-layer recharts-cartesian-axis recharts-yAxis yAxis axis-ticks"
                      >
                        <line
                          orientation="right"
                          stroke="#929292"
                          stroke-width="1"
                          class="recharts-cartesian-axis-line"
                          width="60"
                          height="369"
                          x="540"
                          y="6"
                          fill="none"
                          x1="540"
                          y1="6"
                          x2="540"
                          y2="375"
                        ></line>
                        <g class="recharts-cartesian-axis-ticks">
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              orientation="right"
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              width="60"
                              height="369"
                              x="540"
                              y="6"
                              fill="none"
                              x1="546"
                              y1="375"
                              x2="540"
                              y2="375"
                            ></line>
                            <text
                              orientation="right"
                              stroke="none"
                              stroke-width="1"
                              width="60"
                              height="369"
                              x="548"
                              y="375"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="start"
                              fill="#929292"
                            >
                              <tspan x="548" dy="0.355em">0</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              orientation="right"
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              width="60"
                              height="369"
                              x="540"
                              y="6"
                              fill="none"
                              x1="546"
                              y1="282.75"
                              x2="540"
                              y2="282.75"
                            ></line>
                            <text
                              orientation="right"
                              stroke="none"
                              stroke-width="1"
                              width="60"
                              height="369"
                              x="548"
                              y="282.75"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="start"
                              fill="#929292"
                            >
                              <tspan x="548" dy="0.355em">₹ 30K</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              orientation="right"
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              width="60"
                              height="369"
                              x="540"
                              y="6"
                              fill="none"
                              x1="546"
                              y1="190.5"
                              x2="540"
                              y2="190.5"
                            ></line>
                            <text
                              orientation="right"
                              stroke="none"
                              stroke-width="1"
                              width="60"
                              height="369"
                              x="548"
                              y="190.5"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="start"
                              fill="#929292"
                            >
                              <tspan x="548" dy="0.355em">₹ 60K</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              orientation="right"
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              width="60"
                              height="369"
                              x="540"
                              y="6"
                              fill="none"
                              x1="546"
                              y1="98.25"
                              x2="540"
                              y2="98.25"
                            ></line>
                            <text
                              orientation="right"
                              stroke="none"
                              stroke-width="1"
                              width="60"
                              height="369"
                              x="548"
                              y="98.25"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="start"
                              fill="#929292"
                            >
                              <tspan x="548" dy="0.355em">₹ 90K</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis-tick"
                          >
                            <line
                              orientation="right"
                              stroke="#929292"
                              stroke-width="1"
                              class="recharts-cartesian-axis-tick-line"
                              width="60"
                              height="369"
                              x="540"
                              y="6"
                              fill="none"
                              x1="546"
                              y1="6"
                              x2="540"
                              y2="6"
                            ></line>
                            <text
                              orientation="right"
                              stroke="none"
                              stroke-width="1"
                              width="60"
                              height="369"
                              x="548"
                              y="7.5"
                              class="recharts-text recharts-cartesian-axis-tick-value"
                              text-anchor="start"
                              fill="#929292"
                            >
                              <tspan x="548" dy="0.355em">₹ 2L</tspan>
                            </text>
                          </g>
                        </g>
                        <text
                          offset="5"
                          transform="rotate(90, 586, 190.5)"
                          x="586"
                          y="190.5"
                          class="recharts-text axis-label"
                          text-anchor="middle"
                          fill="#808080"
                        >
                          <tspan x="586" dy="0.355em">
                            EMI paid in the year
                          </tspan>
                        </text>
                      </g>
                      <g class="recharts-layer recharts-bar">
                        <g class="recharts-layer recharts-bar-rectangles">
                          <g class="recharts-layer">
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="88"
                                y="154.51813585388751"
                                width="24"
                                height="220.48186414611249"
                                radius="0"
                                fill="#61399F"
                                name="Principal"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M 88,154.51813585388751 h 24 v 220.48186414611249 h -24 Z"
                              ></path>
                            </g>
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="168"
                                y="92.92323334186631"
                                width="24"
                                height="282.0767666581337"
                                radius="0"
                                fill="#61399F"
                                name="Principal"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M 168,92.92323334186631 h 24 v 282.0767666581337 h -24 Z"
                              ></path>
                            </g>
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="248"
                                y="72.53188107248428"
                                width="24"
                                height="302.4681189275157"
                                radius="0"
                                fill="#61399F"
                                name="Principal"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M 248,72.53188107248428 h 24 v 302.4681189275157 h -24 Z"
                              ></path>
                            </g>
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="328"
                                y="50.66643629878064"
                                width="24"
                                height="324.33356370121936"
                                radius="0"
                                fill="#61399F"
                                name="Principal"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M 328,50.66643629878064 h 24 v 324.33356370121936 h -24 Z"
                              ></path>
                            </g>
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="408"
                                y="27.2203367544285"
                                width="24"
                                height="347.7796632455715"
                                radius="0"
                                fill="#61399F"
                                name="Principal"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M 408,27.2203367544285 h 24 v 347.7796632455715 h -24 Z"
                              ></path>
                            </g>
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="488"
                                y="314.63997667856046"
                                width="24"
                                height="60.36002332143954"
                                radius="0"
                                fill="#61399F"
                                name="Principal"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M 488,314.63997667856046 h 24 v 60.36002332143954 h -24 Z"
                              ></path>
                            </g>
                          </g>
                        </g>
                        <g class="recharts-layer"></g>
                      </g>
                      <g class="recharts-layer recharts-bar">
                        <g class="recharts-layer recharts-bar-rectangles">
                          <g class="recharts-layer">
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="88"
                                y="70.55657244212694"
                                width="24"
                                height="83.96156341176058"
                                radius="2,2,0,0"
                                fill="#DB542A"
                                name="Interest"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M88,72.55657244212694A 2,2,0,0,1,90,70.55657244212694L 110,70.55657244212694A 2,2,0,0,1,
        112,72.55657244212694L 112,154.51813585388751L 88,154.51813585388751Z"
                              ></path>
                            </g>
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="168"
                                y="9.667886930552328"
                                width="24"
                                height="83.25534641131395"
                                radius="2,2,0,0"
                                fill="#DB542A"
                                name="Interest"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M168,11.667886930552328A 2,2,0,0,1,170,9.667886930552328L 190,9.667886930552328A 2,2,0,0,1,
        192,11.667886930552328L 192,92.92323334186628L 168,92.92323334186628Z"
                              ></path>
                            </g>
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="248"
                                y="9.66788693055237"
                                width="24"
                                height="62.8639941419319"
                                radius="2,2,0,0"
                                fill="#DB542A"
                                name="Interest"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M248,11.66788693055237A 2,2,0,0,1,250,9.66788693055237L 270,9.66788693055237A 2,2,0,0,1,
        272,11.66788693055237L 272,72.53188107248427L 248,72.53188107248427Z"
                              ></path>
                            </g>
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="328"
                                y="9.667886930552328"
                                width="24"
                                height="40.99854936822831"
                                radius="2,2,0,0"
                                fill="#DB542A"
                                name="Interest"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M328,11.667886930552328A 2,2,0,0,1,330,9.667886930552328L 350,9.667886930552328A 2,2,0,0,1,
        352,11.667886930552328L 352,50.66643629878064L 328,50.66643629878064Z"
                              ></path>
                            </g>
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="408"
                                y="9.66788693055237"
                                width="24"
                                height="17.552449823876124"
                                radius="2,2,0,0"
                                fill="#DB542A"
                                name="Interest"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M408,11.66788693055237A 2,2,0,0,1,410,9.66788693055237L 430,9.66788693055237A 2,2,0,0,1,
        432,11.66788693055237L 432,27.220336754428494L 408,27.220336754428494Z"
                              ></path>
                            </g>
                            <g class="recharts-layer recharts-bar-rectangle">
                              <path
                                x="488"
                                y="314.11131448842536"
                                width="24"
                                height="0.5286621901350941"
                                radius="2,2,0,0"
                                fill="#DB542A"
                                name="Interest"
                                cursor="pointer"
                                opacity="1"
                                class="recharts-rectangle"
                                d="M488,314.3756455834929A 0.26433109506754704,0.26433109506754704,0,0,1,488.2643310950675,314.11131448842536L 511.7356689049325,314.11131448842536A 0.26433109506754704,0.26433109506754704,0,0,1,
        512,314.3756455834929L 512,314.63997667856046L 488,314.63997667856046Z"
                              ></path>
                            </g>
                          </g>
                        </g>
                        <g class="recharts-layer"></g>
                      </g>
                      <g class="recharts-layer recharts-line">
                        <path
                          stroke="#000000"
                          stroke-width="1"
                          name="Balance"
                          cursor="pointer"
                          opacity="1"
                          fill="none"
                          width="480"
                          height="369"
                          class="recharts-curve recharts-line-curve"
                          stroke-dasharray="489.107666015625px 0px"
                          d="M100,111.596C126.667,130.062,153.333,148.527,180,168.012C206.667,187.497,233.333,207.612,260,228.505C286.667,249.399,313.333,270.968,340,293.372C366.667,315.776,393.333,354.88,420,362.928C446.667,370.976,473.333,372.988,500,375"
                        ></path>
                        <g class="recharts-layer"></g>
                        <g class="recharts-layer recharts-line-dots">
                          <circle
                            r="4"
                            stroke="#000000"
                            stroke-width="1"
                            name="Balance"
                            cursor="pointer"
                            opacity="1"
                            fill="#000000"
                            width="480"
                            height="369"
                            cx="100"
                            cy="111.5963728292225"
                            class="recharts-dot recharts-line-dot"
                          ></circle>
                          <circle
                            r="4"
                            stroke="#000000"
                            stroke-width="1"
                            name="Balance"
                            cursor="pointer"
                            opacity="1"
                            fill="#000000"
                            width="480"
                            height="369"
                            cx="180"
                            cy="168.01172616084926"
                            class="recharts-dot recharts-line-dot"
                          ></circle>
                          <circle
                            r="4"
                            stroke="#000000"
                            stroke-width="1"
                            name="Balance"
                            cursor="pointer"
                            opacity="1"
                            fill="#000000"
                            width="480"
                            height="369"
                            cx="260"
                            cy="228.50534994635242"
                            class="recharts-dot recharts-line-dot"
                          ></circle>
                          <circle
                            r="4"
                            stroke="#000000"
                            stroke-width="1"
                            name="Balance"
                            cursor="pointer"
                            opacity="1"
                            fill="#000000"
                            width="480"
                            height="369"
                            cx="340"
                            cy="293.3720626865963"
                            class="recharts-dot recharts-line-dot"
                          ></circle>
                          <circle
                            r="4"
                            stroke="#000000"
                            stroke-width="1"
                            name="Balance"
                            cursor="pointer"
                            opacity="1"
                            fill="#000000"
                            width="480"
                            height="369"
                            cx="420"
                            cy="362.92799533571065"
                            class="recharts-dot recharts-line-dot"
                          ></circle>
                          <circle
                            r="4"
                            stroke="#000000"
                            stroke-width="1"
                            name="Balance"
                            cursor="pointer"
                            opacity="1"
                            fill="#000000"
                            width="480"
                            height="369"
                            cx="500"
                            cy="375"
                            class="recharts-dot recharts-line-dot"
                          ></circle>
                        </g>
                      </g>
                    </svg>
                    <div
                      class="recharts-legend-wrapper"
                      style="
                        position: absolute;
                        width: 600px;
                        height: auto;
                        left: 0px;
                        bottom: 0px;
                      "
                    >
                      <ul class="flex justify-evenly pt-4">
                        <li class="flex items-center gap-[8px] text-dark-2">
                          <span
                            class="inline-block h-4 w-4"
                            style="
                              border-radius: 2px;
                              background-color: rgb(97, 57, 159);
                            "
                          ></span
                          ><span class="text-sm font-medium text-dark-2"
                            >Principal</span
                          >
                        </li>
                        <li class="flex items-center gap-[8px] text-dark-2">
                          <span
                            class="inline-block h-4 w-4"
                            style="
                              border-radius: 2px;
                              background-color: rgb(219, 84, 42);
                            "
                          ></span
                          ><span class="text-sm font-medium text-dark-2"
                            >Interest</span
                          >
                        </li>
                        <li class="flex items-center gap-[8px] text-dark-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="16"
                            viewBox="0 0 28 16"
                            fill="none"
                          >
                            <rect
                              x="6"
                              width="16"
                              height="16"
                              rx="8"
                              fill="black"
                            ></rect>
                            <rect
                              y="6"
                              width="16"
                              height="4"
                              fill="black"
                            ></rect>
                            <rect
                              x="12"
                              y="6"
                              width="16"
                              height="4"
                              fill="black"
                            ></rect></svg
                          ><span class="text-sm font-medium text-dark-2"
                            >Balance</span
                          >
                        </li>
                      </ul>
                    </div>
                    <div
                      tabindex="-1"
                      class="recharts-tooltip-wrapper"
                      style="
                        visibility: hidden;
                        pointer-events: none;
                        position: absolute;
                        top: 0px;
                        left: 0px;
                      "
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-9 sm:mb-10">
              <div class="no-scrollbar overflow-x-auto">
                <div class="min-w-[600px]">
                  <table
                    class="w-full border-separate border-spacing-0 rounded-2xl border border-gray-200 text-center"
                  >
                    <thead>
                      <tr class="text-center">
                        <th
                          class="text-center not-italic border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6 w-[90px]"
                        >
                          Year
                        </th>
                        <th
                          class="text-center not-italic border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6"
                        >
                          Opening <br />
                          balance
                        </th>
                        <th
                          class="text-center not-italic border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6"
                        >
                          EMI
                        </th>
                        <th
                          class="text-center not-italic border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6"
                        >
                          Interest
                        </th>
                        <th
                          class="text-center not-italic border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6"
                        >
                          Principal
                        </th>
                        <th
                          class="text-center not-italic border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6 w-[77px]"
                        >
                          Loan paid
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button class="ml-2 mr-2 w-[14px] hidden">
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2025</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 5,00,000</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 99,005</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 27,304</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 71,701</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">14.34%</span>
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button class="ml-2 mr-2 w-[14px] hidden">
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2026</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 4,28,298</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 1,18,807</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 27,074</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 91,732</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">32.69%</span>
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button class="ml-2 mr-2 w-[14px] hidden">
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2027</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 3,36,566</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 1,18,807</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 20,443</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 98,363</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">52.36%</span>
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button class="ml-2 mr-2 w-[14px] hidden">
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2028</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 2,38,202</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 1,18,807</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 13,332</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 1,05,474</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">73.45%</span>
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button class="ml-2 mr-2 w-[14px] hidden">
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2029</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 1,32,728</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 1,18,807</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 5,708</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 1,13,099</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">96.07%</span>
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button class="ml-2 mr-2 w-[14px] hidden">
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2030</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 19,629</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 19,801</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 171</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹ 19,629</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">100.00%</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex flex-col text-base font-semibold not-italic leading-6 md:hidden"
          >
            <p class="border-b border-solid border-b-grey-7 pb-6 text-[18px]">
              Related Calculators
            </p>
            <a
              target="_self"
              class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
              href="/calculator/sip-calculator/"
              ><p>SIP calculator</p></a
            ><a
              target="_self"
              class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
              href="/calculator/lumpsum-calculator/"
              ><p>Lumpsum calculator</p></a
            ><a
              target="_self"
              class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
              href="/calculator/home-loan-emi-calculator/"
              ><p>Home loan EMI calculator</p></a
            ><a
              target="_self"
              class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
              href="/calculator/car-loan-emi-calculator/"
              ><p>Car loan EMI calculator</p></a
            ><a
              target="_self"
              class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
              href="/calculator/bike-loan-emi-calculator/"
              ><p>Bike loan EMI calculator</p></a
            ><a
              target="_self"
              class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
              href="/calculator/credit-card-emi-calculator/"
              ><p>Credit card EMI calculator</p></a
            ><a
              target="_self"
              class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
              href="/calculator/personal-loan-emi-calculator/"
              ><p>Personal loan EMI calculator</p></a
            >
          </div>
          <div class="emi-seo-content mt-9 sm:mt-0">
            <h2>EMI Calculator</h2>
            <p>
              With the growing competition in the financial services market,
              consumers now have a plethora of options for loans. While finding
              a trusted financier which offers competitive interest rates is a
              must before applying for a loan, consumers must be conscious of
              how to repay the debt. As most of the loans are repaid through
              EMIs or equated monthly instalments, knowing about the monthly
              outgo is important to avoid financial distress.
            </p>
            <p>
              This is where EMI calculators play a crucial role. An EMI
              calculator is a simple tool which helps a consumer to get an
              estimate of monthly instalment. EMI calculators can easily tell
              you whether a loan at a particular interest rate offered by a
              financier is affordable or not.
            </p>

            <h2>What is an EMI Calculator?</h2>
            <p>
              An EMI calculator is a tool that helps in getting an estimate of
              the monthly instalment of a loan. You need to input details such
              as loan amount, loan term, and interest rate, and the calculator
              will immediately suggest the EMI estimate. Every bank or financial
              products provider has an EMI calculator on its website.
            </p>

            <p>The EMI calculator works using a mathematical formula:</p>
            <p><code>EMI = [P x R x (1 + R)^N] / [(1 + R)^N - 1]</code></p>
            <p>
              In this formula:<br />
              <span>P</span> is the principal loan amount<br />
              <span>R</span> is the monthly interest rate (calculated by
              dividing the annual rate by 12)<br />
              <span>N</span> is the loan tenure in months
            </p>

            <h2>How to Use the EMI Calculator</h2>
            <p>
              Using an EMI calculator is very simple. Follow these steps to use
              an EMI calculator:
            </p>
            <ol>
              <li>Open the EMI calculator.</li>
              <li>Enter the loan amount.</li>
              <li>
                Fill in the interest rate offered by the bank or financier.
              </li>
              <li>Enter the tenure for which you want to take the loan.</li>
              <li>
                Click on Submit and the EMI Calculator will display the
                estimated EMI amount.
              </li>
            </ol>

            <h2>Types of EMI Calculators</h2>
            <p>
              There are various types of online EMI calculators for different
              types of loans. Interest rates for home loans are usually lower
              than other loans such as personal and car loans. Loans are also
              offered with floating rate and fixed rate interests for different
              kinds of borrowings. Different types of EMI calculators include:
            </p>
            <ul>
              <li>Home Loan Calculator</li>
              <li>Car Loan EMI Calculator</li>
              <li>Personal Loan EMI Calculator</li>
              <li>Bike Loan EMI Calculator</li>
              <li>Credit Card EMI Calculator</li>
              <li>Education Loan EMI Calculator</li>
            </ul>

            <h2>Factors Affecting EMI Calculation</h2>
            <p>
              Certain elements such as loan tenure and interest rates affect the
              EMI of a loan. A borrower should consider these elements before
              applying for a loan:
            </p>
            <ul>
              <li>
                <strong>Loan Amount:</strong> The loan amount is the main factor
                which affects the EMI. EMIs will be lower for low loan amounts
                and higher for high amounts, considering the interest rate and
                loan tenure are kept fixed.
              </li>
              <li>
                <strong>Loan Tenure:</strong> Loan tenure also affects the EMI
                amount. At a fixed interest rate and loan amount, EMIs can be
                different for different tenures. Usually, EMIs are higher for
                shorter tenures and lower for longer durations. However,
                interest payable also increases with an increase in loan tenure.
              </li>
              <li>
                <strong>Interest Rate:</strong> EMIs will be high for high
                interest rates and lower for low interest rates offered by a
                bank or lender.
              </li>
              <li>
                <strong>Fixed or Floating Interest Rates:</strong> EMIs of loans
                taken at fixed interest rates remain the same throughout the
                tenure of a loan taken from a lender. However, if the loan is
                taken at floating interest rates, then the EMI will change as
                and when the lender changes the interest rate.
              </li>
            </ul>

            <h2>Benefits of Using an EMI Calculator</h2>
            <ul>
              <li>
                EMI calculators help a borrower to know the EMI amount before
                applying for a loan.
              </li>
              <li>
                EMI calculators help in better financial planning about the loan
                amount, tenure, and interest rate.
              </li>
              <li>You can plan your repayment schedule better.</li>
              <li>
                An estimate of the EMI amount helps to avoid financial burden
                after availing the loan.
              </li>
            </ul>

            <h2>Understanding EMI and Its Components</h2>
            <p>
              EMI or equated monthly instalment is the amount that a borrower
              needs to pay back to a lender against a loan. EMI includes the
              principal and interest. Usually, the interest component is higher
              in initial EMIs and it comes down gradually towards the end of the
              tenure.
            </p>

            <h2>Common Mistakes to Avoid While Using EMI Calculators</h2>
            <ul>
              <li>
                Don’t miss entering the accurate loan amount, interest rate, and
                tenure. Feeding any figure other than your loan details won’t
                provide you with the precise loan amount.
              </li>
              <li>
                Don’t ignore any additional or hidden charges while calculating
                the EMI.
              </li>
              <li>
                It’s a common mistake not to check various loan offers and
                interest rates. Consider the variations in principal amount,
                interest rates, and tenure to get the exact EMI. This will also
                help to get the best loan offer.
              </li>
              <li>
                Factor in any prepayment you are planning. This can
                significantly reduce your EMI amount and also may reduce
                interest rates in some cases.
              </li>
            </ul>

            <h2>Conclusion</h2>
            <p>
              EMI calculators are crucial in better financial planning as these
              help in finding the amount that a borrower can easily afford to
              pay back the loan over a period of time. This ensures better
              compliance by the borrower and helps the borrower to avoid loan
              defaults.
            </p>
          </div>
          <div class="pt-6">
            <span class="text-xl font-semibold not-italic leading-7 text-dark-1"
              >Frequently asked questions</span
            >
            <div class="pt-6">
              <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                <div>
                  <div class="cursor-pointer" @click="changeTab(1)">
                    <div
                      class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                      :data-state="tab[1] ? 'open' : 'closed'"
                    >
                      <div
                        class="inter-display-font flex w-full items-center justify-between"
                      >
                        <h3
                          class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                        >
                          What is an EMI calculator?
                        </h3>
                        <span class="ml-2 flex-shrink-0 text-lg font-bold"
                          ><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=open]:hidden"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                        /></span>
                      </div>
                    </div>
                  </div>
                  <div
                  class="overflow-hidden transition-all duration-300 ease-in-out block"
                    ref="content1"
                    :style="{
                      maxHeight: tab[1] ? content1.scrollHeight + 'px' : '0px',
                    }"
                  >
                    <div
                      class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                    >
                      An online EMI calculator helps you easily reach an
                      estimate of your montly instalments towards loan
                      repayment.
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                <div>
                  <div class="cursor-pointer" @click="changeTab(2)">
                    <div
                      class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                      :data-state="tab[2] ? 'open' : 'closed'"
                    >
                      <div
                        class="inter-display-font flex w-full items-center justify-between"
                      >
                        <h3
                          class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                        >
                          How do I use an EMI calculator?
                        </h3>
                        <span class="ml-2 flex-shrink-0 text-lg font-bold"
                          ><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=open]:hidden"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                        /></span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="overflow-hidden transition-all duration-300 ease-in-out block"
                    ref="content2"
                    :style="{
                      maxHeight: tab[2] ? content2.scrollHeight + 'px' : '0px',
                    }"
                  >
                    <div
                      class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                    >
                      You can feed in loan amount, interest rate and tenure to
                      compute the exact EMI amount.
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                <div>
                  <div class="cursor-pointer" @click="changeTab(3)">
                    <div
                      class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                      :data-state="tab[3] ? 'open' : 'closed'"
                    >
                      <div
                        class="inter-display-font flex w-full items-center justify-between"
                      >
                        <h3
                          class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                        >
                          What factors affect my EMI calculation?
                        </h3>
                        <span class="ml-2 flex-shrink-0 text-lg font-bold"
                          ><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=open]:hidden"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                        /></span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="overflow-hidden transition-all duration-300 ease-in-out block"
                    ref="content3"
                    :style="{
                      maxHeight: tab[3] ? content3.scrollHeight + 'px' : '0px',
                    }"
                  >
                    <div
                      class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                    >
                      Factors like loan amount, tenure and fixed or floating
                      interest rate can affect the EMI.
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                <div>
                  <div class="cursor-pointer" @click="changeTab(4)">
                    <div
                      class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                      :data-state="tab[4] ? 'open' : 'closed'"
                    >
                      <div
                        class="inter-display-font flex w-full items-center justify-between"
                      >
                        <h3
                          class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                        >
                          Can I calculate EMI for different types of loans?
                        </h3>
                        <span class="ml-2 flex-shrink-0 text-lg font-bold"
                          ><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=open]:hidden"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                        /></span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="overflow-hidden transition-all duration-300 ease-in-out block"
                    ref="content4"
                    :style="{
                      maxHeight: tab[4] ? content4.scrollHeight + 'px' : '0px',
                    }"
                  >
                    <div
                      class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                    >
                      Yes, you can use EMI calculator for various loans like
                      home loan, personal loan, car loan, education loan, credit
                      card and more.
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                <div>
                  <div class="cursor-pointer" @click="changeTab(5)">
                    <div
                      class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                      :data-state="tab[5] ? 'open' : 'closed'"
                    >
                      <div
                        class="inter-display-font flex w-full items-center justify-between"
                      >
                        <h3
                          class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                        >
                          What is the formula for calculating EMI?
                        </h3>
                        <span class="ml-2 flex-shrink-0 text-lg font-bold"
                          ><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=open]:hidden"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                        /></span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="overflow-hidden transition-all duration-300 ease-in-out block"
                    ref="content5"
                    :style="{
                      maxHeight: tab[5] ? content5.scrollHeight + 'px' : '0px',
                    }"
                  >
                    <div
                      class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                    >
                      The formula is EMI = [P x R x (1+R)^N] / [(1+R)^N-1],
                      where P is the principal loan amount, R is the monthly
                      interest rate, and N is the loan tenure in months.
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                <div>
                  <div class="cursor-pointer" @click="changeTab(6)">
                    <div
                      class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                      :data-state="tab[6] ? 'open' : 'closed'"
                    >
                      <div
                        class="inter-display-font flex w-full items-center justify-between"
                      >
                        <h3
                          class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                        >
                          Can I prepay my loan EMI?
                        </h3>
                        <span class="ml-2 flex-shrink-0 text-lg font-bold"
                          ><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=open]:hidden"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                        /></span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="overflow-hidden transition-all duration-300 ease-in-out block"
                    ref="content6"
                    :style="{
                      maxHeight: tab[6] ? content6.scrollHeight + 'px' : '0px',
                    }"
                  >
                    <div
                      class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                    >
                      Yes, you can prepay your loan but check the terms and
                      conditions in detail before opting for this.
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                <div>
                  <div class="cursor-pointer" @click="changeTab(7)">
                    <div
                      class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                      :data-state="tab[7] ? 'open' : 'closed'"
                    >
                      <div
                        class="inter-display-font flex w-full items-center justify-between"
                      >
                        <h3
                          class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                        >
                          What happens if I miss an EMI payment?
                        </h3>
                        <span class="ml-2 flex-shrink-0 text-lg font-bold"
                          ><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=open]:hidden"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                            alt="Chevron"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                            style="color: transparent"
                            src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                        /></span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="overflow-hidden transition-all duration-300 ease-in-out block"
                    ref="content7"
                    :style="{
                      maxHeight: tab[7] ? content7.scrollHeight + 'px' : '0px',
                    }"
                  >
                    <div
                      class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                    >
                      Missing an EMI may attract late fees, higher interest. You
                      credit score may also be negatively affected.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="top-28 mt-16 xs:hidden max-w-[320px] shrink-0 self-start md:block"
        >
          <div class="flex flex-col gap-3">
            <div
              class="mb-5 flex flex-col rounded-2xl border border-grey-7 p-4"
            >
              <div class="flex flex-col items-center justify-center">
                <div
                  class="text-center text-[13px] font-semibold not-italic leading-5 text-grey-8"
                >
                  Invest Right, Invest Now
                </div>
                <div
                  class="pt-2 text-center text-lg font-semibold not-italic leading-[26px] text-dark-6"
                >
                  Trusted by 1 cr+ Indians for their wealth-building needs
                </div>
                <div class="my-6 rounded-lg border border-gray-300 px-4">
                  <div class="m-auto mt-2 flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base2">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text--primary-accent relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        0
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-grey-8">
                      Account maintenance charges (AMC)
                    </div>
                  </div>
                  <hr class="my-2 h-px w-full bg-gray-300" />
                  <div class="m-auto flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base2">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text-brand-light-purple relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        0
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-grey-8">
                      Commission on Mutual Funds and IPOs
                    </div>
                  </div>
                  <hr class="my-2 h-px w-full bg-gray-300" />
                  <div class="m-auto mb-2 flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base2">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text-brand-light-purple relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        20
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-grey-8">
                      Brokerage of up to ₹20/order on Equity and F&amp;O
                    </div>
                  </div>
                </div>
              </div>
              <div class="relative flex items-center text-base leading-6">
                <div
                  class="absolute left-4 flex items-center text-sm font-semibold leading-5 text-black top-4"
                >
                  <img
                    alt="indian-flag"
                    loading="lazy"
                    width="16"
                    height="12"
                    decoding="async"
                    data-nimg="1"
                    class="mr-1"
                    style="color: transparent"
                    src="@/styles/img/calculator/next-calculator-assets/indian-flag.svg"
                  /><span class="font-semibold">+91</span>
                </div>
                <input
                  autocomplete="off"
                  autocorrect="off"
                  type="tel"
                  class="h-[52px] w-full gap-3 rounded-lg border border-grey-9 bg-light-1 px-4 py-2 pl-[68px] outline-none"
                  placeholder="Mobile number"
                  name="phoneInput"
                  value=""
                />
              </div>
              <span class="text-xs text-red-600"></span
              ><button
                class="cursor-pointer px-4 text-sm font-semibold disabled:cursor-not-allowed hover-none:bg-primary-dark bg-primary-base text-white active:bg-primary-dark2 disabled:bg-primary-base/50 dark:bg-purpleDark-4 rounded-lg mt-3 w-full py-3"
              >
                Start Investing
              </button>
              <p
                class="pt-2 text-[10px] font-normal not-italic leading-4 text-dark-2"
              >
                By signing up, you agree to receive transaction updates from
                Upstox.
              </p>
            </div>
            <div
              class="flex flex-col text-base font-semibold not-italic leading-6 hidden"
            >
              <p class="border-b border-solid border-b-grey-7 pb-6 text-[18px]">
                Related Calculators
              </p>
              <a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/sip-calculator/"
                ><p>SIP calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/lumpsum-calculator/"
                ><p>Lumpsum calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/home-loan-emi-calculator/"
                ><p>Home loan EMI calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/car-loan-emi-calculator/"
                ><p>Car loan EMI calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/bike-loan-emi-calculator/"
                ><p>Bike loan EMI calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/credit-card-emi-calculator/"
                ><p>Credit card EMI calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/personal-loan-emi-calculator/"
                ><p>Personal loan EMI calculator</p></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped>
</style>
